import React, { useState } from "react";

function WorkItems({item}) {
    const [imageUrl, setImageUrl] = useState("");
    const [showReview, setShowReview] = useState(false);

    const handleImageClick = () => {
      // Ganti URL gambar sesuai kebutuhan Anda
      const sampleImageUrl = item.imgReview;
      setImageUrl(sampleImageUrl);
      setShowReview(true);
    };

    const handleCloseReview = () => {
      setShowReview(false);
    };
  return (
    <div className="work__card " key={item?.id}>
      <div className="work_image_wrapper">
        <img src={item?.image} alt="" className="work__img" />
        <div class="work_overlay work_overlay_5">
          <button class="work_icon" onClick={handleImageClick}>
            <i class="uil uil-image"></i>
          </button>
          <a href={item.github} class="work_icon">
            <i class="uil uil-github"></i>
          </a>
        </div>
      </div>

      {showReview && (
        <div className="work_image-review">
          <button onClick={handleCloseReview}>
            <i class="uil uil-multiply"></i>
          </button>
          <img src={imageUrl} alt="Review" />
        </div>
      )}

      <h3 className="work__title">{item?.title}</h3>
      <a href={item.link} className="work__button">
        Demo <i className="bx bx-right-arrow-alt work__button-icon"></i>
      </a>
    </div>
  );
}

export default WorkItems